export default "__VITE_ASSET__b9b5818d__"